import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Anchor from '../components/Anchor/Anchor';
import BaseLayout from '../components/BaseLayout';
import ForgotPasswordCard from '../components/ForgotPassword/ForgotPasswordCard';
import Paragraph from '../components/Paragraph/Paragraph';

import { PAGES } from '../constants/pages';
import { selectSettings } from '../store/selectors/settingsSelectors';

const ResetSent = () => {
  const { t } = useTranslation();
  const settings = useSelector(selectSettings);
  const { SupportEmail } = settings;

  return (
    <BaseLayout noLogoBox previousPath={PAGES.BASE}>
      <ForgotPasswordCard title={t('resetPassword.title')}>
        <Paragraph mb={28}>
          {t('resetPassword.resetSent.description1')}
          <Anchor
            href={`mailto:${SupportEmail}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('resetPassword.resetSent.descriptionLink')}
          </Anchor>
          {t('resetPassword.resetSent.description2')}
        </Paragraph>
      </ForgotPasswordCard>
    </BaseLayout>
  );
};

export default ResetSent;
